// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__8YsX5","inputWrap":"Table_inputWrap__2hGJt","col":"Table_col__ridOX","bmiTooltip":"Table_bmiTooltip__1SpC7"};